import { lazy } from 'react';

// ----------------------------------------------------------------------

const AssessmentListPage = lazy(() => import('src/pages/assessments/assessment-list-page'));
const AssessmentNewPage = lazy(() => import('src/pages/assessments/assessment-new-page'));
const AssessmentDetailsPage = lazy(() => import('src/pages/assessments/assessment-details-page'));

// ----------------------------------------------------------------------

export const assessmentRoutes = [
  {
    path: 'assessments',
    children: [
      {
        path: ':type',
        children: [
          {
            element: <AssessmentListPage />,
            index: true,
          },
          {
            path: 'new',
            element: <AssessmentNewPage />,
          },
          {
            path: ':assessmentId',
            element: <AssessmentDetailsPage />,
          },
        ],
      },
    ],
  },
];
